import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { intlMessageShape } from 'sb-react-intl'

import Href from 'components/_new/ui/Href/Href'
import Icon from 'components/_new/ui/Icon/Icon'
import Message from 'components/text/Message/Message'

import s from './Link.scss'


const Link = (props) => {
  const { children, href, to, toTab, onClick } = props

  const {
    withArrow, withUnderline, color, uppercase, styleless, disabled,
    className, semibold, message, html, dataTestId, ariaLabel, ariaLabelledBy, ...linkProps
  } = props

  const hrefProps = {
    ...linkProps,
    'data-testid': dataTestId,
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledBy,
  }

  const isNotLink = !href && !to && !toTab

  const content = (
    <Fragment>
      {children || <Message text={message} html={html} />}
      {
        withArrow && (
          <Icon className={s.arrow} name="rightArrowSmall" />
        )
      }
    </Fragment>
  )

  const rootClassName = cx(className, {
    [s.link]: !styleless, // TODO remove hardcoded font-size from Link
    [s.disabled]: disabled,
    [s.uppercase]: uppercase,
    [s.withUnderline]: withUnderline,
    [s[color]]: color,
    [s.semibold]: semibold,
  })

  if (isNotLink) {
    return (
      <span
        className={rootClassName}
        role="button"
        tabIndex={0}
        onClick={onClick}
        data-testid={dataTestId}
        aria-label={ariaLabel}
        aria-labelledby={ariaLabelledBy}
      >
        {content}
      </span>
    )
  }

  return (
    <Href className={rootClassName} {...hrefProps}>
      {content}
    </Href>
  )
}

Link.propTypes = {
  ...Href.propTypes,
  message: PropTypes.oneOfType([
    PropTypes.shape(intlMessageShape),
    PropTypes.string,
  ]),
  uppercase: PropTypes.bool,
  withArrow: PropTypes.bool,
  withUnderline: PropTypes.bool,
  color: PropTypes.oneOf([ 'brand', 'black', 'gray', 'white' ]),
  semibold: PropTypes.bool,
  styleless: PropTypes.bool, // disable hardcoded font-size
  onClick: PropTypes.func,
  ariaLabel: PropTypes.string,
  ariaLabelledBy: PropTypes.string,
  dataTestId: PropTypes.string,
}

Link.defaultProps = {
  withUnderline: true,
  color: 'brand',
}


export default Link
